import {
  GetClassResultAnalysisData,
  GetClassResultAnalysisDataGy25FinalExam,
} from "../../actions/teacherQueries";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import { Row, Col, Card, CardHeader, CardBody, Collapse } from "reactstrap";
import ClassMultipleChoice from "../ResultQuestionOverview/ClassMultipleChoice";
import ClassSequence from "../ResultQuestionOverview/ClassSequence";
import ClassFillIn from "../ResultQuestionOverview/ClassFillIn";
import ClassMatching from "../ResultQuestionOverview/ClassMatching";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import Fab from "@mui/material/Fab";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        right: "-25px",
        position: "absolute",
        top: "50%",
        padding: "0",
        transform: "translate(0, -50%)",
        cursor: "pointer",
        display: "block",
      }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon="chevron-right" style={{ fontSize: "2em" }} />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        left: "-25px",
        position: "absolute",
        top: "50%",
        padding: "0",
        transform: "translate(0, -50%)",
        cursor: "pointer",
        display: "block",
      }}
      onClick={onClick}
    >
      <FontAwesomeIcon icon="chevron-left" style={{ fontSize: "2em" }} />
    </div>
  );
}

export default function ClassResultQuestionOverview({
  classId,
  students,
  courseId,
  moduleId,
  moduleName,
  courseName,
  resultIsOpen,
  toggle,
  isGy25FinalExam,
  variantId,
}) {
  const classResult = isGy25FinalExam
    ? GetClassResultAnalysisDataGy25FinalExam(variantId)
    : GetClassResultAnalysisData(classId, courseId, moduleId);
  function renderSwitch(obj, index) {
    var sliderSettings = {
      className: "slider variable-width",
      dots: true,
      infinite: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      centerPadding: "0",
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };

    switch (obj.type) {
      case "choice":
        return (
          <ClassMultipleChoice
            question={obj.question}
            answersStudent={obj.answersStudent}
            correctAnswer={obj.correctAnswer}
            students={students}
            amountOfStudentresults={obj.amountOfStudentresults}
            sliderSettings={sliderSettings}
            questionIndex={index}
          />
        );
      case "sequencing":
        return (
          <ClassSequence
            question={obj.question}
            answersStudent={obj.answersStudent}
            correctAnswer={obj.correctAnswer}
            students={students}
            amountOfStudentresults={obj.amountOfStudentresults}
            sliderSettings={sliderSettings}
            questionIndex={index}
          />
        );
      case "matching":
        return (
          <ClassMatching
            question={obj.question}
            answersStudent={obj.answersStudent}
            correctAnswer={obj.correctAnswer}
            students={students}
            amountOfStudentresults={obj.amountOfStudentresults}
            sliderSettings={sliderSettings}
            questionIndex={index}
          />
        );
      case "fill-in":
        return (
          <ClassFillIn
            question={obj.question}
            answersStudent={obj.answersStudent}
            correctAnswer={obj.correctAnswer}
            students={students}
            amountOfStudentresults={obj.amountOfStudentresults}
            sliderSettings={sliderSettings}
            questionIndex={index}
          />
        );
      case "true-false":
        return (
          <ClassMultipleChoice
            question={obj.question}
            answersStudent={obj.answersStudent}
            correctAnswer={obj.correctAnswer}
            students={students}
            amountOfStudentresults={obj.amountOfStudentresults}
            sliderSettings={sliderSettings}
            questionIndex={index}
          />
        );
      default:
        return <div></div>;
    }
  }

  if (!classResult.data) {
    return <Pacmanloader />;
  }

  function linesToParagraphs(...nodes) {
    return nodes
      .map((node) =>
        typeof node === "string"
          ? node.split("\n").map((text) => <p className="mb-0">{text}</p>)
          : node
      )
      .reduce((nodes, node) => nodes.concat(node), []);
  }

  return (
    <div>
      {classResult.data && classResult.data.length > 0 && (
        <Row style={{ margin: "2rem auto", display: "block", width: "100%" }}>
          <Card className="px-0">
            <CardHeader
              id={"togglerClassResult"}
              style={{ cursor: "pointer" }}
              onClick={toggle}
            >
              <div
                className="d-flex"
                style={{ marginLeft: "0.5rem", fontWeight: "bolder" }}
              >
                <div className="my-auto me-2">
                  {resultIsOpen ? (
                    <FontAwesomeIcon icon="chevron-down" />
                  ) : (
                    <FontAwesomeIcon icon="chevron-right" />
                  )}
                </div>
                <span>{courseName}</span>
                &nbsp;-&nbsp;
                <span>{moduleName}</span>
              </div>
            </CardHeader>
            <Collapse isOpen={resultIsOpen}>
              <CardBody>
                <Row>
                  {classResult.data.map((obj, index) => {
                    return (
                      <Col key={"qa" + index} md={12}>
                        {renderSwitch(obj, index)}
                      </Col>
                    );
                  })}
                </Row>
                <Fab
                  variant="extended"
                  style={{ backgroundColor: "#20a8d8", color: "white" }}
                  onClick={() => {
                    window.scrollTo({
                      top: 300,
                      behavior: "smooth",
                    });
                  }}
                >
                  <FormattedMessage id="ScrollToFirstQuestion" />
                </Fab>
              </CardBody>
            </Collapse>
          </Card>
        </Row>
      )}
      {classResult.data && classResult.data.length < 1 && (
        <Row
          className="p-1 m-2"
          style={{ border: "2px solid red", borderRadius: "3px" }}
        >
          <Col lg={0.5}>
            <FontAwesomeIcon icon="circle-info" />{" "}
          </Col>
          <Col>
            <h6>
              <FormattedMessage id="ResultOverviewQuestionError">
                {linesToParagraphs}
              </FormattedMessage>
            </h6>
          </Col>
        </Row>
      )}
    </div>
  );
}
